import {PassengerClassType} from "@CheckOrder/features/classPicker/types/PassengerClass.type";

export default function matchPassengerClassTypeAndIcon(type: PassengerClassType) {
    const classIcons: Record<any, "IconDeck" | "IconSeat" | "IconCabin"> = {
        deck: "IconDeck",
        seat: "IconSeat",
        cabin: "IconCabin",
    }

    return classIcons[type] ?? classIcons.deck
}